/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber5Small = createReactComponent("number-5-small", "IconNumber5Small", [
  [
    "path",
    {
      d: "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4",
      key: "svg-0"
    }
  ]
]);

export { IconNumber5Small as default };
//# sourceMappingURL=IconNumber5Small.js.map
